import React from "react";
import { useSelector } from "react-redux";
import { getState } from "../selector-util";
import GoogleChart from "../../../../../components/googleChart/googleChart";

const TableChart = () => {
  let rows = useSelector(state=> getState(state).tableChartData.data_table.rows)
  let columns = useSelector(state=> getState(state).tableChartData.data_table.cols)
  let options = useSelector(state=> getState(state).tableChartData.options)

  return (
    <GoogleChart
      chartName="total_sales_revenue_table_chart"
      width="1350px"
      height={300}
      chartType="Table"
      enableEventListeners={false}
      showAdditionTooltip={false}
      rows={rows}
      columns={columns}
      options={options}
    />
  );
};

export default TableChart;
